import React from "react";
import { Helmet } from "react-helmet-async";

interface Props {
  title: string;
  description?: string;
  image?: string;
}

// Titre/description par route — sans ça, chaque page de l'app partage le <title> statique
// d'index.html, ce qui est mauvais pour le SEO et pour les onglets ouverts en parallèle.
export default function PageMeta({ title, description, image }: Props) {
  const fullTitle = `${title}, OLTODO`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
    </Helmet>
  );
}
